define('collections/member/profiles',[
    'underscore', 'backbone', 'mustache', 'utils',
    // custom
    'services/api',
    // models
    'models/member/profile',
    // parent
    'src/plugins/infinite-collection'
], function(
    _, Backbone, Mustache, U,
    API,
    MProfile,
    // parents
    InfiniteCollection
) {

    var CProfiles = InfiniteCollection.extend({
        model: MProfile,
        state: {
            pageSize: 100,
        },
        queryParams: {
            status: function() {
                return this.status;
            },
            name: function() {
                return this.query;
            },
        },

        comparator: function(model) {
            var lastname = (model.get('lastname') || '').toLowerCase();
            var firstname = (model.get('firstname') || '').toLowerCase();
            return lastname + firstname;
        },

        url: function() {
            var url = 'users/';

            if (this.group) {
                url = Mustache.render('groups/{{{groupId}}}/{{{url}}}', {
                    groupId: this.group.id,
                    url: url
                });
            }

            if (this.group && !this.group.isSupervisor()) {
                url = Mustache.render('groups/{{{groupId}}}/supervisors/', {
                    groupId: this.group.id,
                });
            }

            if (this.supervisors) {
                url = 'users/me/supervisors/';
            }

            return API.url(url);
        },

        initialize: function(models, opt) {
            opt = opt || {};
            if (opt.status) this.status = opt.status;
            if (opt.group) this.setGroup(opt.group);
        },

        parse: function(data, opt) {
            // pass the group id to all the profile object.
            _.each(data, function(profile) {
                profile.group = this.group;
            }, this);

            return CProfiles.__super__.parse.call(this, data, opt);
        },

        getGroup: function() {
            return this.group;
        },

        resetGroup: function() {
            this.group = undefined;
            return this;
        },

        setGroup: function(group) {
            this.group = group;

            this.each(function(profileModel) {
                profileModel.setGroup(this.group);
            }, this);
        },

        setSupervisors: function() {
            this.supervisors = true;
            return this;
        },

        resetSupervisors: function() {
            this.supervisors = false;
            return this;
        },

        fetch: function(opt) {
            opt = opt || {};
            if (opt.group) this.group = opt.group;

            return CProfiles.__super__.fetch.call(this, opt);
        },

        setQuery: function(query) {
            this.query = query;
            return this;
        },

        resetQuery: function() {
            this.setQuery();
            return this;
        }

    });

    return CProfiles;

});

